import { ActionTree } from 'vuex';
import { GlobalState } from '../types';
import { DestinationsState, Destination } from './types';

import * as myetaapi from '../../api/myeta';

export const actions: ActionTree<DestinationsState, GlobalState> = {
    async reload({ commit }) {
        const destinations = await myetaapi.getDestinations();

        commit('resetSelection');
        commit('setDestinations', {
            destinations,
        });
    },

    async select({ commit, dispatch, state }, payload) {
        if ((!state.destinations) ||
            (state.destinations.length == 0)) {
            // reload if needed
            await dispatch('reload');
        }

        if (state.destinations != null) {
            const found: Destination | undefined = state.destinations.find((d) => {
                return d.id === payload;
            });
            if (found)
                commit('setSelected', found);
        }
    },

    async create({ commit }, payload) {
        const destination = await myetaapi.createDestination(payload);
        commit('destinationCreated');
    },

    async update({ commit }, payload) {
        const destination = await myetaapi.updateDestination(payload);
        commit('destinationUpdated');
    },
};
